import { render, staticRenderFns } from "./peaDocuments.vue?vue&type=template&id=615d76c4&scoped=true"
import script from "./peaDocuments.vue?vue&type=script&lang=js"
export * from "./peaDocuments.vue?vue&type=script&lang=js"
import style0 from "./peaDocuments.vue?vue&type=style&index=0&id=615d76c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d76c4",
  null
  
)

export default component.exports